import { render, staticRenderFns } from "./ChemUCI51LCPL3_Q8.vue?vue&type=template&id=3c7fd35e&"
import script from "./ChemUCI51LCPL3_Q8.vue?vue&type=script&lang=ts&"
export * from "./ChemUCI51LCPL3_Q8.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
